lmApp
  .service('SupervisorService', ['$q', 'ApiService',
    function ($q, ApiService) {
      var service = {};

      service.Self = function () {
        return ApiService.Request('1/self', 'GET');
      };

      service.Check = function (email, password) {
        var data = {
          email: email,
          password: password
        };

        return ApiService.Request('1/auth', 'POST', data)
      };

      return service;
    }]);
